import PropTypes from 'prop-types';
import React from 'react';
import { placeholderImages } from '@atc/images';
import { Image } from 'reaxl';
import clsx from 'clsx';

/**
 *  The InventoryImagePlaceholder component is a static component that will render in place of an inventory image when the source is not present.
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function InventoryImagePlaceholder(_ref) {
  let {
    width = 350,
    minWidth,
    height = 282,
    className,
    children,
    lazyload = false,
    imgClassNames,
    noBackground = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "inventoryImagePlaceholder",
    className: clsx('text-subdued-lightest', className, {
      'bg-neutral-tertiary': !noBackground
    }),
    ...rest,
    children: [!!children && children, !children && /*#__PURE__*/_jsx(Image, {
      lazyload: lazyload,
      src: placeholderImages.noImageAvailable,
      alt: "No Image Available",
      className: imgClassNames,
      style: {
        '--aspect-ratio-calculation': `${100 / (width / height)}%`,
        ...(minWidth && {
          minWidth
        }),
        maxWidth: '100%',
        maxHeight: '100%',
        height: height ? `${height}px` : '100%',
        padding: '8%'
      }
    })]
  });
}
export default InventoryImagePlaceholder;